import { Typography } from '@mui/material';

const LicensePlate = ({ children, variant = 'subtitle2', sx = {} }) => {
  return (
    <Typography
      variant={variant}
      sx={{
        px: 1,
        display: 'inline-block',
        whiteSpace: 'nowrap',
        color: '#000',
        fontWeight: 'bold',
        border: '1px solid #616161',
        borderRadius: '2px',
        boxShadow: '2px 2px 2px #ddd',
        width: 'fit-content',
        textDecoration: 'auto!important',
        ...sx
      }}
    >
      {children}
    </Typography>
  );
};

export default LicensePlate;
